import React, { useEffect } from 'react';
import caAPI from "../../services/caAPI";
export default function Logout({ history }) {
    useEffect(() => {
        caAPI.logout();
    }, []);

    return (<></>)
}
